import { render, staticRenderFns } from "./code-manager.vue?vue&type=template&id=6dbc45ea&scoped=true&"
import script from "./js/code-manager.js?vue&type=script&lang=js&"
export * from "./js/code-manager.js?vue&type=script&lang=js&"
import style0 from "./code-manager.vue?vue&type=style&index=0&id=6dbc45ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbc45ea",
  null
  
)

export default component.exports